<!-- popup -->
<!-- PC使用时，应放置于左侧区域内，且容器需要 position:relative -->
<!-- <popup :show.sync="true"></popup> -->
<template>
  <div v-if="show"
    class="bottom-popup animate-quick animate__animated" ref="popup"
    :class="isOpening? 'animate__fadeIn' : 'animate__fadeOut'">
    <div class="bottom-popup-inner animate-quick animate__animated"
      :class="isOpening? 'animate__slideInUp animate__fadeIn' : 'animate__slideOutDown animate__fadeOut'">
      <span v-show="showClose" class="bottom-popup-close" @click="close"></span>
      <div class="bottom-popup-tit">{{title}}</div>
      <div :class="['bottom-popup-container',isShowScroll ? 'overflow-scroll' :'']">
        <slot><!-- content is here --></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 标题文本
    title: {
      default: '',
    },
    // 是否显示，请按照 show.sync 方式使用
    show: {
      default: false,
    },
    // 是否显示关闭按钮
    showClose: {
      default: true,
    },
    // 是否自动将popup-dom插入到合适的位置？
    autoAppend: {
      default: true,
    },
    isShowScroll: {
      default: true,
    },
  },
  data() {
    return {
      // 是否正在打开，用来触发执行动画
      isOpening: false,
    };
  },
  watch: {
    show: {
      handler(val) {
        this.isOpening = val;
      },
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.autoAppend) {
        return;
      }
      // PC下，这个popup插入到IM左侧区域。
      const pcLeftBox = document.querySelector('.html-is-pc .im-msg-container');
      if (pcLeftBox) {
        pcLeftBox.appendChild(this.$el);
      } else {
        document.body.appendChild(this.$el);
      }
    });
  },
  methods: {
    close() {
      this.isOpening = false;
      // 加个延时，等动画值完毕
      setTimeout(() => {
        this.$emit('update:show', false);
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
.animate-quick{
  animation-duration: 0.3s;
}
.cloase-btn(){
    width: 16px;
    height: 16px;
    overflow: hidden;
    position: absolute;
    top: 50%;
    margin-top: -8px;
    right: 12px;
    cursor: pointer;

    &:after,
    &:before {
        content: '';
        width: 16px;
        height: 2px;
        position: absolute;
        top: 50%;
        margin-top: -1px;
        left: 0px;
        background: #a8abb3;
    }
    &:before {
        transform: rotate(-45deg);
    }
    &:after {
        transform: rotate(45deg);
    }

    &:hover,&:active{
        opacity: 0.6;
    }
}

// popup
.bottom-popup{
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;

    .bottom-popup-inner{
        position: absolute;
        box-sizing: border-box;
        width: 100%;
        left: 0;
        bottom: 0;
        min-height: 200px;
        max-height: 500px;
        border-radius: 10px 10px 0 0;
        color:#78849E;
        background: #fff;
        font-size: 14px;
        padding-bottom: calc(~'20px + constant(safe-area-inset-bottom)');
        padding-bottom: calc(~'20px + env(safe-area-inset-bottom)');

        display: flex;
        flex-direction: column;
    }

    .bottom-popup-tit{
        height: 22px;
        line-height: 22px;
        padding: 16px;
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        color: #000000;
    }

    .bottom-popup-container{
        flex: 1;
    }
    .overflow-scroll {
      overflow-y: auto;
    }

    .bottom-popup-close{
        .cloase-btn;

        top: 16px;
        right: 20px;
        margin-top: 0;
    }
}
</style>

<style lang="less">
// PC下的效果
.html-is-pc .bottom-popup{
    position: absolute;

    .bottom-popup-inner{
        max-height: 400px;
    }
}
</style>
